import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../../../../services/modal.service';
import { MaterialsFacadeService } from '../services/materials.facade.service';
import { Configuration } from '../../../../../models/configurators-2d/applications/fence/configuration';
import { FenceService } from '../../../../../services/configurators-2d/applications/fence.service';
import { SubStepEnum } from '../models/sub-step.enum';
import { MaterialSubStepService } from '../services/material-sub-step.service';
import { ColorStateService } from '../../services/color.state.service';

@Component({
  selector: 'ng-casto-materials-boards',
  templateUrl: './materials-boards.component.html',
  styleUrl: './materials-boards.component.scss',
})
export class MaterialsBoardsComponent implements OnInit {
  /** Langue sélectionnée */
  currentLang: string;

  /** Base URL de l'API */
  baseImgURL: string = undefined;
  protected readonly SubStepEnum = SubStepEnum;
  private readonly translateService = inject(TranslateService);
  private readonly materialsFacadeService = inject(MaterialsFacadeService);
  protected readonly modalService = inject(ModalService);
  private readonly fenceService = inject(FenceService);
  private readonly materialSubStepService = inject(MaterialSubStepService);
  private readonly colorStateService = inject(ColorStateService);

  constructor() {
    this.baseImgURL = this.fenceService.apiUrl;
  }

  /**
   * Retourne le message de déréférencement
   */
  protected get disableMessage(): string {
    return this.materialsFacadeService.disableMessage();
  }

  /**
   * Retourne la configuration actuelle
   */
  protected get configuration(): Configuration {
    return this.materialsFacadeService.configuration();
  }


  /**
   * Est-ce que la configuration a des lames désactivées ?
   */
  get configurationHasDisabledColors(): boolean {
    for (const configurationInstallation of this.configuration.configurationInstallations) {
      const colorIds = configurationInstallation.configurationBoards.flatMap(b => b.boardId);
      let colors = this.colorStateService.colorsByInstallations().get(configurationInstallation.installationId);

      // le chargement des données n'est pas encore terminé
      if (!colors) {
        return false;
      }

      colors = colors.filter(c => colorIds.includes(c.id));

      if (colors.some(c => c.isDisabled)) {
        return true;
      }
    }

    return false;
  }

  /**
   * Retourne la sous-étape courante du composant
   * @protected
   */
  protected get subStep(): SubStepEnum {
    return this.materialSubStepService.subStep();
  }

  ngOnInit(): void {
    this.currentLang = this.translateService.getBrowserLang();
  }

  /**
   * Gère l'affichage/masquage des sous-menus en accordéon
   * @param step - Numéro du sous-menu (1: Lames, 2: Poteaux, 3: Lames décoratives, 4: Décors, 5: Panneaux, 6: Portillons)
   */
  protected toggleCollapse(step: SubStepEnum): void {
    this.materialSubStepService.toggleCollapse(step);
  }
}
